export const Config = {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || 'http://localhost:3000',
  API_URL: process.env.API_URL || 'https://api-clonewebx.softlite.io/api',
  API_IFRAME_URL: process.env.API_IFRAME_URL || 'https://clonewebx.softlite.io/api',
  GOOGLE_CLIENT_ID: '355877186155-dqeskbgpim66gveou9rfoq84opkg5fti.apps.googleusercontent.com',
  PLUGIN_VERSION: '1.0.69',
};
